import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  BLACKOUT_HOUR_OPTIONS,
  BLACKOUT_MINUTE_OPTIONS,
  buildTimeHm,
  parseTimeParts,
} from '../types';

/** Hour and minute dropdowns for a single HH:mm value in the rule editor. */
@Component({
  selector: 'blackout-time-dropdown',
  templateUrl: './blackout-time-dropdown.component.html',
  styleUrls: ['./blackout-time-dropdown.component.scss'],
})
export class BlackoutTimeDropdownComponent implements OnInit, OnChanges {

  /** Stored time in HH:mm (24-hour). */
  @Input() value: string | null = null;
  /** SEL-016/019 — accessible name prefix for the selects, e.g. "Start date" */
  @Input() ariaLabel = '';
  @Input() disabled = false;
  @Input() testIdPrefix = 'blackout-time';

  @Output() valueChange = new EventEmitter<string>();

  BLACKOUT_HOUR_OPTIONS = BLACKOUT_HOUR_OPTIONS;
  BLACKOUT_MINUTE_OPTIONS = BLACKOUT_MINUTE_OPTIONS;

  hour = '00';
  minute = '00';

  ngOnInit(): void {
    this.syncFromValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.syncFromValue();
    }
  }

  private syncFromValue(): void {
    const parts = parseTimeParts(this.value);
    this.hour = parts.hour;
    this.minute = parts.minute;
  }

  onChange(): void {
    this.valueChange.emit(buildTimeHm(this.hour, this.minute));
  }
}
